import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "person-card__img-block" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "person-card__img-block-avatar"
}
const _hoisted_4 = { class: "person-card__img-block-flag" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "person-card__text-block" }
const _hoisted_7 = { class: "person-card__name" }
const _hoisted_8 = { class: "person-card__position-wrapper" }
const _hoisted_9 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["person-card", _ctx.className])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.avatar)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "person-card__img-block-avatar",
            src: _ctx.avatar,
            alt: "avatar"
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          class: "person-card__img-flag",
          src: _ctx.flag || '',
          alt: "Флаг страны"
        }, null, 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.name), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", {
          class: "person-card__position",
          title: _ctx.position
        }, _toDisplayString(_ctx.position), 9, _hoisted_9)
      ])
    ])
  ], 2))
}